<template>
    <section class="container">
        <article class="fullCard" v-for="pdf of pdfs" :key="pdf.id">
            <div class="cardContent">
            <button
                class="button is-info"
                :class="{ 'is-loading': loading }"
                v-if="loading == true"
            >e</button>
             <router-link :to="{ name: 'chat', params: { id: pdf.id } }">
                <pdf
                    :src="pdf.coverPdfURL"
                    @page-loaded="currentPage = $event, loading = false"
                    :page=currentPage
                ></pdf>
            </router-link>
            <div class="cardText">
                <router-link :to="{ name: 'chat', params: { id: pdf.id } }">{{pdf.title}}</router-link><br>Publisher: <router-link :to="{ name: 'profile', params: { uid: pdf.owner } }">{{pdf.publisher}}</router-link>
            </div>
            <div class="cardLinks">
            </div>
            </div>
        </article>
    </section>
</template>

<script>

import pdf from 'vue-pdf'
import { db } from '../firebase';

export default {
    components: {
		pdf
    },
    data() {
        return { 
            chats: [],
            loading: true,
            pdfs: []
        }
    },
    computed: {
        articleID() {
            return db.collection('chats');
        }
    },
    firestore() {
        return { 
            pdfs: this.articleID.orderBy('createdAt'),
            chats: db.collection('chats').orderBy('createdAt')
        }
    },
    props: ['show']
}
</script>